import { sendAppsignalError, displayToast } from "../modules/utils";
class NewsFilter {
  constructor(node) {
    this.element = node;
    this.hiddenInput = this.element.querySelector(".js-news-filter-input");
    this.newsWrapper = this.element.querySelector(".js-news-filter-content");

    this.url = new URL(this.element.dataset.newsUrl, window.location.origin);
    this.initialize();
  }

  initialize() {
    this.hiddenInput.addEventListener("change", (e) => {
      const { name, value } = e.target;

      this.url.searchParams.set(name, value);

      this.filterNews();
    });
  }

  filterNews() {
    this.newsWrapper.classList.add("is-loading");

    fetch(this.url, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("filterNews failed");
      })
      .then((data) => {
        this.newsWrapper.innerHTML = data.html;
        window.Beyuna.initClasses(this.newsWrapper);
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "NewsFilter", {
          response: this.response,
        });
      })
      .finally(() => {
        this.newsWrapper.classList.remove("is-loading");
      });
  }
}

const news = document.querySelector('[data-js="news-filter"]');

if (news) {
  new NewsFilter(news);
}
